import { useContext } from 'react';
import { context } from './utils.tsx';

export function useDndItem() {
	return useContext(context);
}

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default } from './view';
